export default function useIsFocused(): boolean {
  return true
}
